(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bra-size-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bra-size-filter')) {
    customElements.define('bra-size-filter', class extends HTMLElement {
      connectedCallback() {
        this.selected = new Set(new URL(location.href).searchParams.getAll('bra_size').map(s => s.replace(/\s/g, '').toUpperCase()));
        this.section = this.closest('.shopify-section');
        this.busy = false;
        this.onChange = event => {
          if (!event.target.matches('[data-options] input')) return;
          if (event.target.checked) this.selected.add(event.target.value); else this.selected.delete(event.target.value);
          this.apply(true);
        };
        this.onClick = event => {
          if (event.target.closest('[data-clear]')) { this.selected.clear(); this.updateOptions(); this.apply(true); }
          if (event.target.closest('[data-retry]')) this.refresh();
        };
        this.onPop = () => {
          this.selected = new Set(new URL(location.href).searchParams.getAll('bra_size').map(s => s.replace(/\s/g, '').toUpperCase()));
          this.updateOptions(); this.apply(false);
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        window.addEventListener('popstate', this.onPop);
        this.observer = new MutationObserver(mutations => {
          if (mutations.some(m => [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches('#product-grid, .grid__item, .collection') || n.querySelector('#product-grid'))))) {
            clearTimeout(this.timer); this.timer = setTimeout(() => this.refresh(), 30);
          }
        });
        this.observer.observe(this.section.querySelector('#ProductGridContainer'), { childList:true, subtree:true });
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect(); clearTimeout(this.timer); this.controller?.abort();
        this.removeEventListener('change',this.onChange); this.removeEventListener('click',this.onClick);
        window.removeEventListener('popstate',this.onPop);
      }
      cards() { return [...this.section.querySelectorAll('#product-grid > [data-bra-sizes]')]; }
      sizes(card) { return new Set(card.dataset.braSizes.split('|').map(size => size.replace(/\s/g,'').toUpperCase()).filter(Boolean)); }
      async refresh() {
        if (this.busy) { this.again = true; return; }
        this.busy = true; this.querySelector('fieldset').disabled = true;
        this.querySelector('[data-error]').hidden = true;
        this.controller = new AbortController();
        const grid = this.section.querySelector('#product-grid');
        try {
          let next = this.section.querySelector('.pagination-wrapper a.pagination__item--prev');
          const visited = new Set();
          while (next && !visited.has(next.href)) {
            const url = new URL(next.href); visited.add(next.href);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) url.searchParams.set('preview_theme_id',preview);
            const response = await fetch(url, { signal:this.controller.signal });
            if (!response.ok) throw new Error('Unable to load collection');
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            if (grid !== this.section.querySelector('#product-grid')) { this.again = true; return; }
            const ids = new Set(this.cards().map(c => c.dataset.braProduct));
            doc.querySelectorAll('#product-grid > [data-bra-sizes]').forEach(card => { if (!ids.has(card.dataset.braProduct)) { card.classList.remove('scroll-trigger'); grid.appendChild(card); } });
            const old = this.section.querySelector('.pagination-wrapper');
            const replacement = doc.querySelector('.pagination-wrapper');
            if (old && replacement) old.replaceWith(replacement); else old?.remove();
            next = this.section.querySelector('.pagination-wrapper a.pagination__item--prev');
          }
          this.section.querySelector('.pagination-wrapper')?.setAttribute('hidden','');
          this.section.querySelector('#InfiniteScrollLoader')?.classList.add('hidden');
          this.updateOptions(); this.apply(false);
          this.querySelector('fieldset').disabled = false;
        } catch(error) {
          if (error.name !== 'AbortError') { this.querySelector('[data-error]').hidden = false; this.querySelector('[data-status]').textContent = ''; }
        } finally {
          this.busy = false;
          if (this.again && this.isConnected) { this.again = false; this.refresh(); }
        }
      }
      updateOptions() {
        const all = new Set(this.cards().flatMap(c => [...this.sizes(c)]));
        this.selected.forEach(s => all.add(s));
        const sorted = [...all].sort((a,b) => a.localeCompare(b,undefined,{numeric:true}));
        const box = this.querySelector('[data-options]');
        if (box.dataset.sizes !== JSON.stringify(sorted)) {
          box.replaceChildren(...sorted.map(size => {
            const label = document.createElement('label'); label.className = 'bra-size-filter__option';
            const input = document.createElement('input'); input.type = 'checkbox'; input.value = size;
            const text = document.createElement('span'); text.textContent = size;
            label.append(input,text); return label;
          }));
          box.dataset.sizes = JSON.stringify(sorted);
        }
        box.querySelectorAll('input').forEach(input => input.checked = this.selected.has(input.value));
      }
      apply(save) {
        const cards = this.cards(); let count = 0;
        cards.forEach(card => {
          const sizes = this.sizes(card);
          const match = !this.selected.size || [...this.selected].some(size => sizes.has(size));
          card.hidden = !match; if (match) count++;
        });
        const label = this.dataset.count.replace('[count]',String(count));
        this.querySelector('[data-status]').textContent = label;
        this.section.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(node => { if(node.textContent.trim() !== label) node.textContent = label; });
        this.querySelector('[data-selection]').textContent = this.selected.size ? `(${this.selected.size})` : '';
        this.querySelector('[data-empty]').hidden = count > 0;
        const url = new URL(location.href); url.searchParams.delete('bra_size');
        [...this.selected].sort().forEach(size => url.searchParams.append('bra_size',size));
        if (save && url.href !== location.href) history.pushState({...history.state},'',url);
        else if (!save && url.href !== location.href) history.replaceState({...history.state},'',url);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
